export const FROM_AC_COMPONENT = 'AC'
export const FROM_CHART_COMPONENT = 'Chart'
